import apiClient from "../apiClient";
import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const CategoriesAdd = () => {
    const [category, setCategory] = useState({
        Description: "",
        IsSavingsCategory: 0,
        IsIncomeCategory: 0,
        });

    const [error, setError] = useState(false)

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setCategory((prev) => ({ ...prev, [name]: type === "checkbox" ? (checked ? 1 : 0) : value }));
        }

    const handleClick = async(e) => {
        e.preventDefault();
        if (!category.Description?.trim()) return setError(true);
        try {
            await apiClient.post("/categories", category);
            navigate("/Categories");
        } catch (err) {
            console.log(err);
            setError(true)
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Add Category</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Categories">Categories</Link> / Add</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="category-description">Category Description</label>
                    <input
                        id="category-description"
                        type="text"
                        placeholder="e.g. Transport"
                        name="Description"
                        value={category.Description}
                        onChange={handleChange}
                    />
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsSavingsCategory"
                            checked={Boolean(category.IsSavingsCategory)}
                            onChange={handleChange}
                        />
                        <span>Savings category</span>
                    </label>
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsIncomeCategory"
                            checked={Boolean(category.IsIncomeCategory)}
                            onChange={handleChange}
                        />
                        <span>Income category</span>
                    </label>
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Add Category</button>
                        <Link className="btn-link" to="/Categories">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not save category. Check input and try again.</p>}
                </div>
            </section>
        </div>
             );
    };

export default CategoriesAdd;
